import React, { Component } from 'react';
import { Dropdown } from './';
import { Avatar, Icon } from '@material-ui/core';

class UsersSelector extends Component {
  userDropdown = null;

  componentDidUpdate() {
    if (window.innerWidth < 480 && document.getElementsByClassName('chips-wrapper')[0]) {
      let height = 115 + document.getElementsByClassName('chips-wrapper')[0].clientHeight;
      document.getElementsByClassName('wrapper')[0].style.top = height + 'px';

      let cw = document.getElementsByClassName('chips-wrapper')[0];
      cw.scrollTo(0, cw.scrollHeight);
    }
  }

  selectUser(userId) {
    let user = this.props.users.filter(user => { return user.uid === userId; })[0];

    // if (!user) {
    //   user = this.props.teams.filter(team => { return team.key === userId})[0];
    // }

    this.props.setSelectedUsers( [ ...this.props.selectedUsers, user ]);
  }

  renderChips() {
    return this.props.selectedUsers.map(user => {
      const { photoURL } = user;

      user.deleteClick = () => {
        let selectedUsers = this.props.selectedUsers;
        selectedUsers.splice(selectedUsers.map(user => user.key || user.uid).indexOf(user.uid || user.key), 1);
        this.props.setSelectedUsers(selectedUsers);
      };

      return (
        <div
          className="chip-wrapper"
          key={user.uid || user.key}
        >
          <Avatar className="chip-user-icon" alt="sender" src={photoURL} />
          <span className="chip-user-name">
            {user.displayName || user.name}
          </span>
          <Icon
            className="chip-delete"
            onClick={() => user.deleteClick()}
          >
            close
          </Icon>
        </div>
      );
    });
  }

  render() {
    const { users, placeholder, selectedUsers } = this.props;
    const userIds = selectedUsers.map(user => user.key || user.uid);
    const dropdownItems = users.filter(user => userIds.indexOf(user.key || user.uid) === -1);

    return (
      <div onClick={() => { if (window.innerWidth < 480) this.userDropdown.openDropdown(); }} className="chips-wrapper">
        {this.renderChips()}
        <Dropdown
          noAutoFocus={true}
          ref={(ref) => this.userDropdown = ref}
          items={dropdownItems}
          dropdownNum="0"
          display="displayName"
          clearTextAfterSelect={true}
          placeholder={placeholder ? placeholder : ''}
          itemKey="uid"
          clearSelection={() => this.setState({ selectedUserID: null })}
          selectItem={uid => this.selectUser(uid)}
          onDelete={() => {
            if (selectedUsers.length > 0) {
              selectedUsers[selectedUsers.length - 1].deleteClick();
            }
          }}
        />
      </div>
    );
  }
}

export { UsersSelector };


// WEBPACK FOOTER //
// ./src/components/UsersSelector.js